// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CreditCardOutlinedSvg from "@ant-design/icons-svg/es/asn/CreditCardOutlined";
import AntdIcon from '../components/AntdIcon';

var CreditCardOutlined = function CreditCardOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardOutlinedSvg
  }));
};

CreditCardOutlined.displayName = 'CreditCardOutlined';
export default React.forwardRef(CreditCardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CreditCardOutlined.js
// module id = 887
// module chunks = 0